var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M612.4,481.1C607.9,476.6,625.3,495.9,612.4,481.1L612.4,481.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.2,266.4c-4-5.6-9.5-10.3-16.2-13.3c-6.1-2.8-12.8-4.1-19.4-3.8c-0.7,0-1.3,0.1-2,0.1c0,0,0,0,0,0c-1.7,0.1-3.4,0.4-5,0.8c-8.2,1.7-15.9,5.9-21.6,12.4c-0.3,0.3-75.6,85.4-146.9,165.7c-1.7,1.9-3.4,3.9-4.9,6c-13.3,18-8.7,45.3,9.8,57.6c18.9,12.6,40.4,9.8,56.1-7.8c24.9-27.9,49.7-55.9,74.5-83.9c0,87.2,0,174.4,0,261.6c0,2.6,0,5.2,0.3,7.7c2,22.3,23.5,39.6,45.5,36.6c22.5-3.1,36.7-19.5,36.8-43.1c0.1-54.1,0-108.3,0-162.4c0-25.1,0-50.3,0-75.4c0-8.4,0-16.8,0.1-25.3c12.1,13.8,24.2,27.7,36.3,41.5c16.6,18.9,16.1,18.4,32.7,37.3c0.8,0.9,1.4,1.6,2,2.3c1,1,2.9,3.1,6.5,6.9c20.3,21.9,57.2,14,67.7-14c6.3-16.8,2.1-31.4-9.5-44.6C606.3,348.9,604.5,346.7,534.2,266.4L534.2,266.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.2,10C229.5,9.9,9.8,229.6,10,500.2C10.2,771,230.1,990.6,500.6,990c271-0.7,489.8-219.8,489.4-490.2C989.6,228.9,770.9,10.2,500.2,10L500.2,10z M500,922.1C266.8,922.1,78,733.2,78,500C78,266.7,266.9,77.9,500.1,77.9C733.3,78,922.3,267,922.3,500C922.2,733.2,733.2,922.1,500,922.1L500,922.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade);
export default __webpack_public_path__ + "static/media/upgrade.e3bb9bd106fa8b258d6aa805aacf4f6e.svg";
export { ForwardRef as ReactComponent };